// import { NgxEchartsModule } from "ngx-echarts"
import { CommonModule, registerLocaleData } from "@angular/common"
// import { DashboardModule } from "./modules/dashboard/dashboard.module"

import {
  provideHttpClient,
  withInterceptorsFromDi,
  withJsonpSupport
} from "@angular/common/http"
// import { DashboardModule } from "./modules/dashboard/dashboard.module"
import localeGB from "@angular/common/locales/en-GB"
import { NgModule } from "@angular/core"
import { initializeApp, provideFirebaseApp } from "@angular/fire/app"
// import { HttpInterceptorService } from './shared/services/http-interceptor.service';
import { connectAuthEmulator, getAuth, provideAuth } from "@angular/fire/auth"
import {
  connectFirestoreEmulator,
  getFirestore,
  provideFirestore
} from "@angular/fire/firestore"
import {
  connectFunctionsEmulator,
  getFunctions,
  provideFunctions
} from "@angular/fire/functions"
import { FormsModule, ReactiveFormsModule } from "@angular/forms"
import { MatButtonModule } from "@angular/material/button"
import { MatCardModule } from "@angular/material/card"
import { MAT_DATE_LOCALE } from "@angular/material/core"
import { MatDatepickerModule } from "@angular/material/datepicker"
import { MatIconModule } from "@angular/material/icon"
import { MatMenuModule } from "@angular/material/menu"
import { MatRadioModule } from "@angular/material/radio"
import { MatSlideToggleModule } from "@angular/material/slide-toggle"
import { BrowserModule } from "@angular/platform-browser"
import { BrowserAnimationsModule } from "@angular/platform-browser/animations"
import { RouterModule } from "@angular/router"
import { environment } from "@env"
import { validationSuiteProviders } from "@ngc-validate/validators"
// import { CalendarModule, DateAdapter } from "angular-calendar"
// import { adapterFactory } from "angular-calendar/date-adapters/date-fns"
import { ToastrModule } from "ngx-toastr"

import { AppRoutingModule } from "./app-routing.module"
import { AppComponent } from "./app.component"
import { AuthModule } from "./modules/auth/auth.module"
import { NotFoundComponent } from "./shared/not-found/not-found.component"
import { SharedModule } from "./shared/shared.module"

registerLocaleData(localeGB)

@NgModule({
  declarations: [AppComponent, NotFoundComponent],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    // NoopAnimationsModule,
    SharedModule,
    RouterModule,
    AppRoutingModule,
    AuthModule,
    // DashboardModule,
    ToastrModule.forRoot(),
    MatCardModule,
    MatButtonModule,
    // CalendarModule.forRoot({
    //   provide: DateAdapter,
    //   useFactory: adapterFactory
    // }),
    MatDatepickerModule,
    MatIconModule,
    MatMenuModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => {
      const auth = getAuth()
      if (environment.useEmulators) {
        connectAuthEmulator(auth, "http://localhost:9099", {
          disableWarnings: false
        })
      }
      return auth
    }),
    provideFirestore(() => {
      const fs = getFirestore()
      if (environment.useEmulators) {
        connectFirestoreEmulator(fs, "localhost", 8080)
      }
      return fs
    }),
    provideFunctions(() => {
      const funcs = getFunctions()
      if (environment.useEmulators) {
        connectFunctionsEmulator(funcs, "localhost", 5001)
      }
      return funcs
    }),
    provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
    { provide: MAT_DATE_LOCALE, useValue: "en-GB" },
    validationSuiteProviders
  ]
})
export class AppModule {}
